import React, { Component } from "react";

const Customers = () => {
  return <h1>Hello World from customers</h1>;
};

export default Customers;
